import * as Yup from 'yup';
import { CommonMessages } from 'src/validation/CommonMessages';

const ProjectValidationSchema = Yup.object().shape({
  t_client_id: Yup.string()
    .required(CommonMessages.required('Client')),

  name: Yup.string()
    .required(CommonMessages.required('Project name')),

  name_abbreviation: Yup.string()
    .required(CommonMessages.required('Project name (abbreviation)')),

  category_cd: Yup.string()
    .required(CommonMessages.required('Project Category')),

  order_price: Yup.string()
    .required(CommonMessages.required('Order amount (excluding tax)')),

  order_price_tax_rate: Yup.number()
    .nullable() // Allow null values
    .transform((originalValue) => {
      const parsedValue = originalValue === '' || isNaN(originalValue) ? null : Number(originalValue);
      return parsedValue;
    })
    .required(CommonMessages.required('Consumption tax rate'))
    .max(100, 'Tax rate must not be greater than 100'),

  start_date: Yup.date()
    .nullable()
    .required(CommonMessages.required('Project duration Start Date'))
    .transform((originalValue) => {
      if (originalValue === '') return null;
      const parsedDate = new Date(originalValue);
      if (isNaN(parsedDate)) return null;
      return parsedDate;
    }),

  end_date: Yup.date()
    .nullable()
    .required(CommonMessages.required('Project duration End Date'))
    .transform((originalValue) => {
      if (originalValue === '') return null;
      const parsedDate = new Date(originalValue);
      if (isNaN(parsedDate)) return null;
      return parsedDate;
    })
    .min(
            Yup.ref('start_date'),
            CommonMessages.after('End Date', 'Start Date')
        ),

  manager_id: Yup.string()
    .required(CommonMessages.required('Project Leader')),

  sub_manager_id: Yup.string()
    .required(CommonMessages.required('Project Sub-Leader')),

});

export default ProjectValidationSchema;
